import React, { useContext } from "react";
import DemoTable from "./Tables/DemoTable";
import UserInputTable from "./Tables/UserInputTable";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { AppContext } from "../Utils/Context";
import "../Styles/Tables.css";

const Tables = ({ generatedData }) => {
  const {
    setSubscribedTopicString,
    activeTab,
    setActivetab,
    activeDataChip,
    setActiveDataChip,
  } = useContext(AppContext);

  const handleTabClick = (tab) => {
    setActivetab(tab);
    localStorage.setItem("LastActiveTab", JSON.stringify(tab));
    setSubscribedTopicString("");
  };

  const activateDataChip = (type) => {
    setActiveDataChip(type);
    localStorage.setItem("LastActiveDataChip", JSON.stringify(type));
    setSubscribedTopicString("");
  };

  const getChipStyles = (chipLabel) => ({
    backgroundColor: activeDataChip === chipLabel ? "#d7d7d9" : "default",
    "&:hover": {
      backgroundColor: activeDataChip === chipLabel ? "#a6c8ff" : "#e0e0e0",
    },
    fontFamily: "Arial",
  });

  return (
    <div>
      <div className="datasets-title">
        <h2>Datasets</h2>
      </div>

      <div className="tabs">
        <div
          className={`demo-tab ${activeTab === "demo" ? "active" : ""}`}
          onClick={() => handleTabClick("demo")}
        >
          Demo
        </div>
        <div
          className={`try-it-tab ${activeTab === "try-it" ? "active" : ""}`}
          onClick={() => handleTabClick("try-it")}
        >
          Try It With Your Own Data
        </div>
      </div>

      <div className="divider"></div>

      {activeTab === "demo" ? (
        <Stack direction="row" spacing={1} className="chip-stack">
          <Chip
            label="Retail Enterprise"
            variant="outlined"
            onClick={() => activateDataChip("retail")}
            sx={getChipStyles("retail")}
          />
          <Chip
            label="Airline"
            variant="outlined"
            onClick={() => activateDataChip("airline")}
            sx={getChipStyles("airline")}
          />
          <Chip
            label="Car Manufacturer"
            variant="outlined"
            onClick={() => activateDataChip("car_maker")}
            sx={getChipStyles("car_maker")}
          />
          <Chip
            label="Rail Operator"
            variant="outlined"
            onClick={() => activateDataChip("rail_operator")}
            sx={getChipStyles("rail_operator")}
          />
          <Chip
            label="Financial Institution"
            variant="outlined"
            onClick={() => activateDataChip("finance")}
            sx={getChipStyles("finance")}
          />
        </Stack>
      ) : (
        <></>
      )}

      <div className="table-container">
        {activeTab === "demo" ? (
          <DemoTable />
        ) : (
          <UserInputTable generatedData={generatedData} />
        )}
      </div>
    </div>
  );
};

export default Tables;
